// extracted by mini-css-extract-plugin
export default {"bot":"Bot_bot__PoPBd"};